
export class Constants {
  public static readonly LOGIN_URI = '/api/auth/login';
  public static readonly REPORTS = '/api/reports';
  public static readonly REFRESH_URI = "/api/auth/refresh";
  public static readonly CHANGE_PASSWORD = "/api/change-password";
  public static readonly ADD_REPORT = "/api/admin/reports";
  public static readonly EMAIL_TXT = "Email";
  public static readonly USERNAME_TXT = "User name";
  public static readonly USERID_TXT = "User id";
  public static readonly ROLE_NAME_TXT = "Role name";
  public static readonly ROLE_ID_TXT = "Role id";
  public static readonly CUSTOMER_NAME_TXT = "Customer name";
  public static readonly PASSWORD_CHANGED_TXT = "Password changed";
  public static readonly BTN_TXT_YES = "Yes";
  public static readonly BTN_TXT_SAVE = "Save";
  public static readonly SUCCESS_TXT = "Success";
  public static readonly BTN_TXT_ADD = "Add";
  public static readonly ERROR_MSG = {
    Internal_Server_Error: "Unable to connect to server right now. Please try agian later",
    CURRENT_NEW_PSWD_SAME: "New password cannot be the same as your current password.",
    NEW_CONFIRM_PSWD_MISMATCH: "New Password and Confirm Password do not match",
  }

  public static readonly CUSTOMER_CONST = {
    SEARCH_PLACEHOLDER: "Search customer name",
    CUSTOMER_HEADER_ARR: ['user_id', 'username', 'email', 'role_id', 'role_name', 'customer_name', 'is_Admin', "password_changed"],
    DELETE_POPUP_TITLE: 'Delete customer',
    DELETE_POPUP_BODY_TXT: 'This will permanently remove the selected customer. Proceed?',
    DELETE_CUST_SUCCESS_TXT: "Customer deleted successfully",
    EDIT_POPUP_TITLE: 'Edit customer',
    EDIT_CUST_SUCCESS: "Customer details updated successfully",
    ADD_POPUP_TITLE: 'Add customer',
    ADD_CUST_SUCCESS: "New customer added successfully"

  }

  public static readonly REPORT_DETAIL_CONST = {
    ADD_NEW_REPORT: "Add New Report",
    ADD_REPORT_SUCCESS_MSG: "New report added successfully",
    EDIT_REPORT: "Edit Report",
    EDIT_REPORT_SUCCESS_MSG: "Report updated successfully",
  }

  public static readonly ROLE_DETAIL_CONST = {
    PRIMARY_BTN_TXT: "Add",
    ADD_NEW_ROLE: "Add New Role",
    ADD_ROLE_SUCCESS_MSG: "New role added successfully",
    EDIT_ROLE: "Edit Role",
    EDIT_ROLE_SUCCESS_MSG: "Role updated successfully",
  }


  public static readonly REFRESH_TOKEN = 'refresh_token';
  public static readonly ACCESS_TOKEN = 'access_token';
  public static readonly TIMEOUT_TITLE = "Session expired";
  public static readonly TIMEOUT_BODY = "Your login session has expired. Please login again.";
  public static readonly PASS_CHANGE_SUCCESS_TITLE = "Password changed successfully";
  public static readonly PASS_CHANGE_TEXT = 'Password updated successfully. Please login again.'


}
